import { Directive, ElementRef, HostListener } from '@angular/core';
import { NumberWithSpacesPipe } from '../pipes/number-with-spaces.pipe';

@Directive({
  selector: '[inputFormatter]'
})
export class InputFormatterDirective {

  private el: any;

  constructor(private elementRef: ElementRef, private numberWithSpace: NumberWithSpacesPipe) {
    this.el = this.elementRef.nativeElement;
    window.setTimeout(() => {
      this.el.focus();
    });
  }

  @HostListener("focus", ["$event.target.value"])
  onFocus(value) {
    this.el.value = this.numberWithSpace.transform(value);
  }

  @HostListener("keypress", ["$event"])
  onKeyPress(event: KeyboardEvent) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  @HostListener("keyup", ["$event.target.value"])
  onKeyup(value) {
    this.el.value = this.numberWithSpace.transform(value);
  }

  @HostListener("keydown", ["$event.target.value"])
  onKeydown(value) {
    this.el.value = value.replace(new RegExp(" ", "g"), "");
  }

}
